// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RescriptReactRouter from "../../../../../../@rescript/react/src/RescriptReactRouter.bs.js";

function handleClick(href, $$event) {
  if (!$$event.defaultPrevented) {
    $$event.preventDefault();
    return RescriptReactRouter.push(href);
  }
  
}

function LinkComponent(Props) {
  var href = Props.href;
  var classNameOpt = Props.className;
  var children = Props.children;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("a", {
              className: "link " + className,
              href: href,
              onClick: (function ($$event) {
                  return handleClick(href, $$event);
                })
            }, children);
}

var make = LinkComponent;

export {
  handleClick ,
  make ,
  
}
/* react Not a pure module */
